<template>
  <v-row>
    <v-col sm="10" md="10" lg="10">
      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate>
        <h2>
          <slot></slot>
        </h2>
        <div class="dropbox">
          <input
            type="file"
            multiple
            @change="
              filesChange($event.target.files);
              fileCount = $event.target.files.length;
            "
            accept="image/*, application/pdf"
            class="input-file"
          />
          <p v-show="isInitial || isSuccess">
            Drag your pdf or image file(s) here to begin <br />or click to
            browse
          </p>
          <p center>
            <v-icon x-large>cloud_upload</v-icon>
          </p>
          <p v-show="isSaving">Uploading {{ fileCount }} files...</p>
        </div>
        <v-progress-linear
          :indeterminate="isSaving"
          v-show="isSaving"
        ></v-progress-linear>
      </form>

      <div v-if="isDownloading">
        <span>Downloading</span>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>

      <div v-if="isDeleting">
        <span>Deleting</span>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>

      <!--SUCCESS-->
      <div v-if="isSuccess || rows.length > 0">
        <h2>Uploaded {{ rows.length }} file(s) successfully.</h2>
        <strong>Click a button below to download individual files.</strong>
        <v-data-table
          :headers="headers"
          :items="rows"
          class="elevation-1"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td class="text-left">
              <v-btn
                text
                icon
                color="green"
                @click="downloadAttachment(props.item)"
              >
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </td>
            <td class="text-left">
              <b>{{ props.item.filename }}</b>
            </td>
            <td class="text-left">{{ props.item.contentType }}</td>
            <td class="text-left">
              <v-btn
                v-if="!isDeleting"
                text
                icon
                color="red"
                @click="removeAttachment(props.item)"
              >
                <v-icon>cancel</v-icon>
                <v-progress-circular
                  v-show="isDeleting"
                  indeterminate
                  color="red"
                ></v-progress-circular>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <h2>Uploaded failed.</h2>
        <p>
          <a href="javascript:void(0)" @click="reset()">Try again</a>
        </p>
        <pre>{{ uploadError }}</pre>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import mockUploads from "@/helpers/mockUploads";
import { mapUploadMultiRowFields } from "@/store/modules/forms/upload";
const { mapActions: mapUploadActions } = createNamespacedHelpers(`uploads`);

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "FileUploader",
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      fileCount: 0,
      files: new FormData(),
      rows: mockUploads,
      headers: [
        {
          text: "Download",
          align: "left",
          sortable: false,
          value: "true"
        },
        {
          text: "File Name",
          align: "left",
          sortable: true,
          value: "filename"
        },
        {
          text: "Content Type",
          align: "left",
          sortable: true,
          value: "contentType"
        },
        {
          text: "Remove",
          align: "left",
          sortable: false,
          value: "true"
        }
      ],
      isDownloading: false,
      isDeleting: false
    };
  },
  watch: {
    isDownloading(val) {
      if (val) return setTimeout(() => (this.isDownloading = false), 1000); //Added a small delay just in case of super-quick downloads.
    },
    isDeleting(val) {
      if (val) return setTimeout(() => (this.isDeleting = false), 1000);
    }
  },
  computed: {
    //...mapUploadMultiRowFields(["rows"]),
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },

  methods: {
    ...mapUploadActions([
      "populateUploads",
      "updateUploadsOnOrder",
      "removeRows",
      "setMessage",
      "UploadToKayako",
      "getAttachment",
      "deleteAttachment",
      "getExtension"
    ]),
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.files = new FormData();
      this.fileCount = 0;
    },
    save() {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      const vm = this;
      vm.updateUploadsOnOrder(vm.files)
        .then(x => {
          vm.uploadedFiles = [].concat(x.files);
          this.currentStatus = STATUS_SUCCESS;
          this.currentStatus = STATUS_INITIAL;
        })
        .catch(err => {
          vm.uploadError = err.response;
          //vm.isFailed();
          //setTimeout(() => vm.currentStatus = STATUS_FAILED, 1000);
          this.currentStatus = STATUS_FAILED;
        });
      //vm.uploadedFiles = [].concat(x.files);
    },
    downloadAttachment(item) {
      let vm = this;
      this.isDownloading = true;
      this.getAttachment(item).then(x => {
        vm.downloadAttachment = false;
        vm.$forceUpdate();
      });
    },
    filesChange(fileList) {
      // handle file changes
      let vm = this;
      var allowed = [];
      if (!fileList.length) return;
      vm.fileCount = fileList.length;
      // append the files to FormData

      Array.from(Array(fileList.length).keys()).map(x => {
        vm.files.append("files", fileList[x], fileList[x].name);
      });

      // save it
      vm.save();
    },
    removeAttachment(file) {
      let vm = this;
      //
      vm.isDeleting = true;
      vm.deleteAttachment(file.fileGuid)
        .then(x => {
          vm.isDeleting = false;
          //this.fileCount = fileList.length;
          vm.reset();
          vm.populateUploads();
        })
        .catch(err => {
          vm.uploadError = err.response;
        });
    },
    setIcon(type) {
      if (type == "application/pdf" || type == "application/text") {
        return;
      } else {
        return "photo";
      }
    }
  },
  mounted() {
    this.reset();
    // this.populateUploads();
  }
};
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
